import { gql } from "@apollo/client";

export const FILES_UPLOAD = gql`
  mutation v1_files_upload($prm: v1_files_upload_prm!) {
    v1_files_upload(prm: $prm)
  }
`;